export const CultureCode = {
  US: "en-US",
  GB: "en-GB",
};
